import Vue from 'vue'
import Router from 'vue-router'

import index from '../components/index'
import pc_login from '../components/pc_login'
import app_login from '../components/app_login'
import pc_dp from '../components/pc_dp'
import app_dp from '../components/app_dp'
import {getCodeByParseUrl} from '../common/js/help.js'
import {getWxUser, refreshToken,isGz} from '../api/jwt.js'


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '首页',
        login: true
      }
    },
    {
      path: '/pc_login',
      name: 'pc_login',
      component: pc_login,
      meta: {
        title: '智慧屏',
        login: true
      }
    },
    {
      path: '/app_login',
      name: 'app_login',
      component: app_login,
      meta: {
        title: '智慧屏',
        login: true
      }
    },
    {
      path: '/pc_dp',
      name: 'pc_dp',
      component: pc_dp,
      meta: {
        title: '智慧屏',
        login: true
      }
    },
    {
      path: '/app_dp',
      name: 'app_dp',
      component: app_dp,
      meta: {
        title: '智慧屏',
        login: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log(from.meta.title+' 标题 ' + to.meta.title);
  // 标题更改
  if (to.matched.some(record => record.meta.title)) {
    window.document.title = to.meta.title;
  }

  // 判断是跳转电脑还是手机
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  let token = localStorage.getItem('Authorization');
  //判断是否记住密码
  let rememberMeFlag = localStorage.getItem('rememberMeFlag');
  // if(token){
  //   var dataObj = JSON.parse(token);
  //   if ((new Date().getTime() - dataObj.time > 180000) && !rememberMeFlag) {
  //     localStorage.removeItem('Authorization');
  //     token = null;
  //   } else {
  //     token = dataObj.data;
  //   }
  // }
  if (token === null || token === '') {
    if (flag) {
      if (to.path === '/app_login') {
        return next();
      }
      return next('/app_login');
    } else{
      if (to.path === '/pc_login') {
        return next();
      }
      return next('/pc_login');
    }
  }
  if(flag){
    if(to.path === '/app_dp'){
      return next();
    }
    return next('/app_dp');
  }else {
    if(to.path === '/pc_dp'){
      return next();
    }
    return next('/pc_dp');
  }
  return next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js